import { CacheKey } from '../types/cache-keys';
import { UserProductExpertise, UserProductExpertiseWrite } from '../types/user';
import { useAddItemMutation, useDeleteItemMutation, useFetchItems, useUpdateItemMutation } from './base-hooks';

const useFetchUserProductExpertise = (userId: number, options?) =>
  useFetchItems<UserProductExpertise[]>(
    'db/user-product-expertise',
    () => [CacheKey.UserProductExpertise, userId],
    { user_id: userId },
    { enabled: !!userId, ...options }
  );

const useCreateUserProductExpertiseMutation = () =>
  useAddItemMutation<UserProductExpertise>(
    'db/user-product-expertise',
    () => [CacheKey.UserProductExpertise]
  );

const useUpdateUserProductExpertiseMutation = () =>
  useUpdateItemMutation<UserProductExpertise & UserProductExpertiseWrite, UserProductExpertise>(
    'db/user-product-expertise',
    (payload) => [CacheKey.UserProductExpertise, payload.id]
  );

const useDeleteUserProductExpertiseMutation = () =>
  useDeleteItemMutation<UserProductExpertise>(
    'db/user-product-expertise',
    (payload) => [CacheKey.UserProductExpertise, payload.id]
  );

export {
  useFetchUserProductExpertise,
  useCreateUserProductExpertiseMutation,
  useUpdateUserProductExpertiseMutation,
  useDeleteUserProductExpertiseMutation,
};
